import React from 'react';

/**
 * Telegram-style quick reply chips under assistant messages.
 */
export default function MessageInlineActions({ actions, disabled, onAction }) {
  if (!actions?.length) return null;

  return (
    <div className="chat-module-actions" role="group" aria-label="Быстрые ответы">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className={`chat-module-chip${action.variant === 'explain' ? ' chat-module-chip--muted' : ''}${action.variant === 'handoff' ? ' chat-module-chip--handoff' : ''}`}
          disabled={disabled}
          onClick={() => onAction(action)}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}
